module.exports = __webpack_public_path__ + "img/modelo_valle.bdb5ff63.png";